import type { IntegrationProvider } from '@brew/integration-contracts'

const BREW_CDN_BASE_URL = 'https://cdn.brew.new'

type IntegrationLogoAsset = {
  icon: string
  wordmark: string
}

function logoUrl(
  provider: IntegrationProvider,
  asset: keyof IntegrationLogoAsset
) {
  return `${BREW_CDN_BASE_URL}/integrations/integration-${provider}-${asset}.png`
}

export const INTEGRATION_LOGO_ASSETS = {
  // Reuse the bundled Loops mark already shipped in the onboarding flow.
  loops: {
    icon: '/integrations/loops.png',
    wordmark: '/integrations/loops.png',
  },
  framer: {
    icon: 'https://cdn.brew.new/assets/2026/09/framer-logo-222ccf2c.svg',
    wordmark: 'https://cdn.brew.new/assets/2026/09/framer-logo-222ccf2c.svg',
  },
  braze: {
    icon: logoUrl('braze', 'icon'),
    wordmark: logoUrl('braze', 'wordmark'),
  },
  brevo: {
    icon: logoUrl('brevo', 'icon'),
    wordmark: logoUrl('brevo', 'wordmark'),
  },
  clerk: {
    icon: logoUrl('clerk', 'icon'),
    wordmark: logoUrl('clerk', 'wordmark'),
  },
  customerio: {
    icon: logoUrl('customerio', 'icon'),
    wordmark: logoUrl('customerio', 'wordmark'),
  },
  figma: {
    icon: logoUrl('figma', 'icon'),
    wordmark: logoUrl('figma', 'wordmark'),
  },
  slack: {
    icon: logoUrl('slack', 'icon'),
    wordmark: logoUrl('slack', 'wordmark'),
  },
  hubspot: {
    icon: logoUrl('hubspot', 'icon'),
    wordmark: logoUrl('hubspot', 'wordmark'),
  },
  typeform: {
    icon: logoUrl('typeform', 'icon'),
    wordmark: logoUrl('typeform', 'wordmark'),
  },
  klaviyo: {
    icon: logoUrl('klaviyo', 'icon'),
    wordmark: logoUrl('klaviyo', 'wordmark'),
  },
  iterable: {
    icon: logoUrl('iterable', 'icon'),
    wordmark: logoUrl('iterable', 'wordmark'),
  },
  postmark: {
    icon: logoUrl('postmark', 'icon'),
    wordmark: logoUrl('postmark', 'wordmark'),
  },
  onesignal: {
    icon: logoUrl('onesignal', 'icon'),
    wordmark: logoUrl('onesignal', 'wordmark'),
  },
  mailgun: {
    icon: logoUrl('mailgun', 'icon'),
    wordmark: logoUrl('mailgun', 'wordmark'),
  },
  sendgrid: {
    icon: logoUrl('sendgrid', 'icon'),
    wordmark: logoUrl('sendgrid', 'wordmark'),
  },
  mailjet: {
    icon: logoUrl('mailjet', 'icon'),
    wordmark: logoUrl('mailjet', 'wordmark'),
  },
  mailchimp: {
    icon: logoUrl('mailchimp', 'icon'),
    wordmark: logoUrl('mailchimp', 'wordmark'),
  },
  stripe: {
    icon: logoUrl('stripe', 'icon'),
    wordmark: logoUrl('stripe', 'wordmark'),
  },
  stytch: {
    icon: logoUrl('stytch', 'icon'),
    wordmark: logoUrl('stytch', 'wordmark'),
  },
  supabase: {
    icon: logoUrl('supabase', 'icon'),
    wordmark: logoUrl('supabase', 'wordmark'),
  },
  workos: {
    icon: logoUrl('workos', 'icon'),
    wordmark: logoUrl('workos', 'wordmark'),
  },
  shopify: {
    icon: logoUrl('shopify', 'icon'),
    wordmark: logoUrl('shopify', 'wordmark'),
  },
  revenuecat: {
    icon: logoUrl('revenuecat', 'icon'),
    wordmark: logoUrl('revenuecat', 'wordmark'),
  },
} satisfies Record<IntegrationProvider, IntegrationLogoAsset>

export function integrationLogoAssetUrl(
  provider: IntegrationProvider,
  variant: 'card' | 'dialog'
): string {
  return INTEGRATION_LOGO_ASSETS[provider][
    variant === 'card' ? 'icon' : 'wordmark'
  ]
}
